import axios from 'axios'
import {getStorage} from './storage'
import router from '@/router-v2'
import matchWhitelist from "@/router-v2/whitelist";
import path from 'path';
import APImatchWhitelist from "@/utils/APImatchWhitelist";
import {systemInfo} from "@/shared-services";
import {storeAdapter$} from "@/store/adapter";
const fleetApiPattern = new RegExp(`^${ path.join('/fleet(/.*)?') }`, 'i')
const commandCenterApiPattern = new RegExp(`^${ path.join('/(zuul|sso)(/.*)?') }`, 'i')

const service = axios.create({
  baseURL: process.env.VUE_APP_URL,
  timeout: 50000
})
const isPre = process.env.VUE_APP_BUILD_ENV === 'pre';

service.interceptors.request.use(
  config => {
    if(isPre && config.url) {
      if(config.url.startsWith('/command-center/')) {
        config.url = config.url.replace('/command-center/', '/command-center-pre/')
      }
    }
    const uri = axios.getUri(config);
    // fleet api
    if (fleetApiPattern.test(uri) || commandCenterApiPattern.test(uri)) {
      if (typeof config.headers['portal-token'] !== 'string') {
        if (getStorage('x-portal-token') === 'yes') {
          delete config.headers['portal-token']
          config.headers['x-portal-token'] = getStorage()
        } else {
          if (getStorage()) {
            config.headers['portal-token'] = getStorage() 
          } else if (getStorage('commandTemporaryToken')) {
            config.headers['portal-token'] = getStorage('commandTemporaryToken')
          }
        }
      }
      if(commandCenterApiPattern.test(uri)) {
        config.headers['system-source'] = systemInfo.isCommand ? "fleet" : "dispatcher";
      }
      return config;
    }

    if (!config.headers['disable-token']) {
      if (config.method === 'get') {
        config.data = { unused: 0 }
        config.headers['Content-Type'] === 'application/json;charset=UTF-8'
      }
      config.headers['x-auth-token'] = process.env.VUE_APP_TOKEN
      config.headers['client'] = process.env.VUE_APP_CLIENT
      config.headers['Installation-ID'] = process.env.VUE_APP_INSTALLATION_ID
      config.headers['Access-Control-Allow-Headers'] = '*'
      config.headers['Access-Control-Allow-Methods'] = 'PUT,POST,GET,DELETE,OPTIONS'
      config.headers['Access-Control-Allow-Origin'] = '*'
    } else {
      delete config.headers['disable-token']
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

service.interceptors.response.use(
  response => response,
  error => {
    const response = error.response;
    if (response) {
      if (response.status === 401 && systemInfo.isCommand) {
        console.log('responsecConfigUrl',response.config.url)
        if (!matchWhitelist(router.currentRoute.path) && APImatchWhitelist.indexOf(response.config.url)== -1) {
          return storeAdapter$.next(['dispatch', ["user/logout"]]);
        }
      }
    }
    if((error + '').indexOf('timeout') !== -1) {
      return Promise.reject("Request timed out, please try again.");
    }
    return Promise.reject(error);
  }
);

export default service
